import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, UncontrolledTooltip} from "reactstrap";
import QSignPracovnikApi from "../../api/gen/qsign/QSignPracovnikApi";
import {Loader, modal} from "@mc/mc-legacy";
import CreateSignersForm from "../forms/CreateSignersForm";

class SignersField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            podepisujici: [],
        }
    }

    handleChangeSigners = (value) => {
        const { dispatch, onChange } = this.props;
        dispatch(
            modal.ModalActions.showAsyncWaiting(
                "Načítání nastavení podepisujících",
                <Loader />,
                QSignPracovnikApi.findAllActive(),
                (pracovnici) => {
                    const pracovniciTransform = pracovnici.map(item => {
                        return ({
                            id: item.id,
                            name: `${item.uplneJmeno} ${item.organizacniJednotka ? `(${item.organizacniJednotka.kod})` : ""}`,
                            title: item.organizacniJednotka.nazev,
                        });
                    });
                    this.setState({podepisujici: pracovniciTransform})
                    dispatch(
                        modal.ModalActions.show(
                            CreateSignersForm,
                            {
                                onSubmit: (data) => {
                                    onChange(data.signers);
                                    return Promise.resolve();
                                },
                                onSubmitSuccess: (result, dispatch) => {
                                    dispatch(modal.ModalActions.hide());
                                },
                                initialValues: {
                                    signers: value || [{pracovnikId: null, signerDescription: null}]
                                },
                                podepisujici: pracovniciTransform,
                            },
                            "Nastavení podepisujících",{
                                size: "lg",
                            }
                        )
                    );
                }
            )
        );
    };

    render() {
        const {value, onChange, dispatch, disabled} = this.props;
        const vybraniPodepisujici = [];
        let info = null;
        if (value) {
            value?.map(signer => {
                this.state.podepisujici.map(podepisujici => {
                    podepisujici.id === signer.pracovnikId ? vybraniPodepisujici.push(podepisujici) : ""
                })
            })
            if (vybraniPodepisujici.length === 1) {
                info = vybraniPodepisujici[0].name;
            }
            if (vybraniPodepisujici.length > 1) {
                info = <><span style={{cursor:"help"}} id={"tooltip"}>{`Nastaveno ${vybraniPodepisujici.length} podepisujících`}</span>
                    <UncontrolledTooltip placement={"right"} target={"tooltip"}>
                        {vybraniPodepisujici.map(podepisujici => <p>{podepisujici.name}</p>)}
                    </UncontrolledTooltip>
                </>

            }
        }
        let render = <Button type="button" disabled={disabled} onClick={() => this.handleChangeSigners(value)}>Nastavit
            podepisující</Button>
        if (value && value.length > 0) {
            render = <div>{render} {info}</div>
        }
        return (
            <div className="approval-field">
                {render}
            </div>
        );
    }
}

export default connect((state) => {
    return {};
})(SignersField);
